import {
  consolidationCartonIdFormat,
  consolidationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const consolidationCartonLabelInputSchema = z.object({
  cartonId: consolidationCartonIdFormat.schema,
  consolidationId: consolidationIdFormat.schema,
});
